"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var Filters_1 = require("components/Filters/Filters");
var Pagination_1 = require("components/Pagination/Pagination");
var Page_1 = require("modules/Page");
var Initializer_1 = require("modules/Initializer");
require("./job-listings-page.scss");
var JobListingsPage = (function (_super) {
    __extends(JobListingsPage, _super);
    function JobListingsPage(selector, rootElement) {
        var _this = _super.call(this, selector, rootElement) || this;
        _this.selector = selector;
        _this.rootElement = rootElement;
        _this.searchParams = new URLSearchParams(window.location.search);
        Filters_1.filters.init();
        Filters_1.filters.get(window.location.search);
        Pagination_1.pagination.init();
        _this.initMobileFilterButton();
        _this.initRadiusFilter();
        return _this;
    }
    JobListingsPage.prototype.initMobileFilterButton = function () {
        var mobileFilterButton = document.querySelector("#filter-mobile");
        var element = this.rootElement.querySelector(".open-positions");
        if (mobileFilterButton && element)
            element.insertAdjacentElement("beforeend", mobileFilterButton);
    };
    JobListingsPage.prototype.initRadiusFilter = function () {
        var _a, _b, _c;
        var radiusFilterElement = this.rootElement.querySelector("#radius");
        var dl = radiusFilterElement === null || radiusFilterElement === void 0 ? void 0 : radiusFilterElement.closest("dl");
        var radiusFilterValueElement = this.rootElement.querySelector("#radius-value");
        var locationsFilterDiv = this.rootElement.querySelector("div[name='Locations']");
        if (!locationsFilterDiv || !radiusFilterElement || !radiusFilterValueElement || !dl)
            return;
        var radius = this.searchParams.get("radius");
        if (radius != null) {
            radiusFilterElement.value = radius;
            radiusFilterValueElement.textContent = radius + " km";
        }
        this.observeLocationsFilter(locationsFilterDiv, dl);
        var selectedLocations = locationsFilterDiv.querySelectorAll(".checked");
        if (selectedLocations.length) {
            (_a = dl.querySelector(".filter-content")) === null || _a === void 0 ? void 0 : _a.classList.add("active");
        }
        else {
            (_b = dl.querySelector(".filter-custom")) === null || _b === void 0 ? void 0 : _b.classList.remove("active");
            (_c = dl.querySelector(".filter-content")) === null || _c === void 0 ? void 0 : _c.classList.remove("active");
        }
        radiusFilterElement.addEventListener("input", function (event) {
            if (!(event.target instanceof HTMLInputElement))
                return;
            radiusFilterValueElement.textContent = event.target.value + " km";
        });
    };
    JobListingsPage.prototype.observeLocationsFilter = function (locationsFilterDiv, dl) {
        var config = { attributes: true, childList: true, subtree: true };
        var callback = function (mutationList) {
            var e_1, _a;
            var _b, _c;
            try {
                for (var mutationList_1 = __values(mutationList), mutationList_1_1 = mutationList_1.next(); !mutationList_1_1.done; mutationList_1_1 = mutationList_1.next()) {
                    var mutation = mutationList_1_1.value;
                    if (mutation.type === "attributes" && mutation.attributeName === "class") {
                        var selectedLocations = locationsFilterDiv.querySelectorAll(".checked");
                        if (!selectedLocations.length) {
                            (_b = dl.querySelector(".filter-content")) === null || _b === void 0 ? void 0 : _b.classList.remove("active");
                        }
                        else {
                            (_c = dl.querySelector(".filter-content")) === null || _c === void 0 ? void 0 : _c.classList.add("active");
                        }
                        return;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (mutationList_1_1 && !mutationList_1_1.done && (_a = mutationList_1.return)) _a.call(mutationList_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        var observer = new MutationObserver(callback);
        observer.observe(locationsFilterDiv, config);
    };
    JobListingsPage.selector = ".js-job-listings-page";
    return JobListingsPage;
}(Page_1.Page));
Initializer_1.Initializer.initPage(JobListingsPage.selector, JobListingsPage);
